import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import HelpNavButton from '../components/HelpNavButton';
import { showModal as showAccessibilityModal } from '../redux/accessibility/actions';

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showAccessibilityModal,
    },
    dispatch,
  );

export default connect(null, mapDispatchToProps)(HelpNavButton);
